import { faCircleNotch, faFilePdf, faPrint, faRetweet } from '@fortawesome/free-solid-svg-icons'
import { Container, Item, ItemDataStore, PrintableReport, PrintableReportDataStore, PrintableReportFormat, SearchResult, Wemi, exportItem } from '@skinsoft/entity'
import { ReactiveVue } from '@skinsoft/reactive-vue'
import { AllItemDisplayForm } from '@skinsoft/ui/src/all-item-display-form'
import { pluck, tap } from 'rxjs/operators'
import { PropType } from 'vue'
import Component from 'vue-class-component'
import * as pdfJs from 'pdfjs-dist'
import { imageToZ64 } from 'zpl-image'
import pako from 'pako'

import { SelectItemMultipleForm } from '../../../../../entity/component/select-item-multiple-modal/select-item-multiple-form'
import { noop } from 'lodash'

const PAGE_SIZE = 10

require('./bar-code-editor.scss')

@Component({
    components: {
        sSelectItemMultipleForm: SelectItemMultipleForm,
    },
    props: {
        types: Array as PropType<string[]>,
    },
    template: require('./bar-code-editor.html'),
})
export class BarCodeEditor extends ReactiveVue {
    public items: Array<Wemi | SearchResult> = []
    public maxItemNumber = 0
    public printableReports: PrintableReport[] = []
    public selectedReportId: string | null = null

    private types: Array<string>
    private shouldBeRotated: boolean = true

    private rotationIcon = faRetweet
    private loadingIcon = faCircleNotch
    private pdfIcon = faFilePdf
    private printerIcon = faPrint

    private $itemDataStore: ItemDataStore
    private $printableReportDataStore: PrintableReportDataStore


    private mounted() {
        this.performSearch()
        this.$printableReportDataStore.getAllReportsOfTypesAndFormats(
            ['595ca6a7857aba0001ac6442'], 
            [PrintableReportFormat.INDIVIDUAL_LABEL]
        ).subscribe(reports => {
            this.printableReports = reports
            this.selectedReportId = this.printableReports[0]?.id
        })
    }

    private onItemSelectedZpl(item: any, actionBefore: () => void = noop) {
        if (this.selectedReportId) {
            actionBefore()
            exportItem(item.id, this.$i18n.locale, this.selectedReportId, this.shouldBeRotated).subscribe(async pdf => {
                const canvas = document.createElement('canvas')
                const page = await (await pdfJs.getDocument(URL.createObjectURL(pdf))).getPage(1)
                const viewport = page.getViewport({ scale: 6.0 })
                canvas.height = viewport.height
                canvas.width = viewport.width
                await page.render({
                    canvasContext: canvas.getContext('2d'),
                    viewport
                }).promise
                // necessary to use the zpl-image library (issue reference: https://github.com/metafloor/zpl-image/issues/10)
                // @ts-ignore
                window.pako = pako
                const z64Image = imageToZ64(canvas)
                const zpl = `^XA\n` + // start print
                            `^GFA,${z64Image.length},${z64Image.length},${z64Image.rowlen},${z64Image.z64}\n` + // display image
                            `^XZ` // end print
                const downloadable = new File([new Blob([zpl])], '', { type: 'application/octet-stream' })
                const link = document.createElement('a')
                link.href = URL.createObjectURL(downloadable)
                link.download = `${item.id}-label.zpl`
                link.click()

                setTimeout(() => {
                    const linkOpenApp = document.createElement('a')
                    linkOpenApp.href = 'intent://#Intent;package=com.zebra.printersetup;end' // zebra printer setup android intent
                    linkOpenApp.click()
                }, 500)
                this.$emit('barcode-item-selected')
            })
        }
    }

    private onItemSelectedPdf(item: any, actionBefore: () => void = noop) {
        if (this.selectedReportId) {
            actionBefore()
            exportItem(item.id, this.$i18n.locale, this.selectedReportId, this.shouldBeRotated).subscribe(pdf => {
                const pdfUrl = URL.createObjectURL(pdf)
                window.open(pdfUrl)
                this.$emit('barcode-item-selected')
            })
        }
    }

    private performSearch(searchText = '', pageNumber = 0) {
        this.$itemDataStore
            .searchAll(searchText, null, PAGE_SIZE, this.types, pageNumber)
            .pipe(
                tap(searchResult => (this.maxItemNumber = searchResult.totalSize)),
                pluck('allData'),
            )
            .subscribe(items => (this.items = items))
    }
}
